import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { getLogger } from '@coolblue-development/react-logging';
import NullLogger from './nullLogger.js';
let logger;
export const useClientLogger = () => {
    const { environment, language, subsidiary } = useRequestContext();
    if (!logger) {
        logger = createClientLogger().withEnricher({
            enrich: () => ({
                /**
                 * These tags are dynamic for each and every request on this instance.
                 * They can be different for each request, and therefore determined runtime.
                 */
                get Environment() {
                    return environment;
                },
                get Language() {
                    return language;
                },
                get Subsidiary() {
                    return subsidiary;
                },
            }),
        });
    }
    return logger;
};
export const createClientLogger = () => {
    if (typeof window === 'undefined') {
        return new NullLogger();
    }
    return getLogger();
};
//# sourceMappingURL=clientLogger.js.map